module.exports = __webpack_public_path__ + "static/media/(H)-02_-_bijuterias_-_acessorios.e73934de.jpg";